import React, { useState, useEffect, useContext } from 'react';
import { GetAllAditivosComArquivoSgc } from '../../../api/contrato/aditivosContrato';
import { Widget, usePromise } from '@digital/ui';
import { Icon, Collapse, Descriptions } from 'antd';
import TabelaArquivoAditvo from './tabelaArquivoAditvo';
import ComponeteCurso from '../../../components/componeteCurso';
import { hasPermission } from '@app/helpers/permissions';
const { Panel } = Collapse;

interface PropsAditovoArquivos {
  contratoId: string;
  atualizarGridAnexoAditivo: boolean;
  onUpdatePage: () => any;
}

const AditivosArquivos = (props: PropsAditovoArquivos) => {
  const { contratoId, atualizarGridAnexoAditivo, onUpdatePage } = props;
  const [aditivoComArquivo, setAditivoComArquivo] = useState(false);

  const AtualizarTabela = () => {
    setAditivoComArquivo(true);
    setAditivoComArquivo(false);
  };

  useEffect(() => {
    setAditivoComArquivo(true);
  }, []);

  const [listAditivoComArquivo] = usePromise(
    () => (contratoId ? GetAllAditivosComArquivoSgc(contratoId) : Promise.resolve(undefined)),
    [aditivoComArquivo, atualizarGridAnexoAditivo],
    [],
  );

  return (
    <>
      {listAditivoComArquivo.map(item => (
        <Collapse
          key={item.id + 'collapse'}
          bordered={false}
          expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key={item.id} header={'Aditivo: ' + item.ordem} style={{ border: 0 }}>
            <Widget>

              {hasPermission(['CONTRATO_GERAL_ANEXOS_CONTRATO_ADITIVOS']) ? (<>
                <div className="ant-app-unboxed-button">
                  <ComponeteCurso
                    id={item.id}
                    nomeIdFormulario={'aditivoId'}
                    enderecoApi={'aditivos/updateArquivoContratoAditivos'}
                    descricaoBotao={'Incluir Arquivo'}
                    retorno={data => {
                      if (data.valid) {
                        onUpdatePage();
                        setAditivoComArquivo(!aditivoComArquivo);
                      }
                    }}
                    idDoComponente={item.id}
                  />
                </div>
              </>) : (<> </>)}

              <TabelaArquivoAditvo aditivoId={item.id} atualizarTela={aditivoComArquivo} />
            </Widget>

          </Panel>
        </Collapse>
      ))}
    </>
  );
};

export default AditivosArquivos;
